import Request from "./Request"

export const LogInUser = (body:{email:string, password:string}) => {
    return Request('POST', `/session/`, body);
} 
  